import { useQuery } from "react-query";
import { getDealerGroups } from "../requests/getDealerGroups";

export default function useGetDealerGroups(
  dealerId: string,
  ivideonIsAuth: string | null,
  cameraStatus?: number,
) {
  return useQuery({
    queryKey: ["ivideon_groups_cameras", dealerId],
    queryFn: () => getDealerGroups(dealerId, ivideonIsAuth),
    refetchOnWindowFocus: false,
    enabled: !!ivideonIsAuth && !!cameraStatus,
    cacheTime: 0,
    refetchOnMount: "always",
  });
}
